<app-loader
	[enableCircle]="true"
	[isActive]="this.isLoadingAsync | async"
></app-loader>
<h1 matDialogTitle>
	<div class="flex flex-row items-center justify-start">
		<div>{{ 'workspace.create' | translate }}</div>
		<div class="flex-auto"></div>
		<button
			mat-icon-button
			matDialogClose
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</h1>

<mat-dialog-content>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.wsGroup"
	>
		<div class="flex flex-col items-stretch justify-start">
			<mat-form-field>
				<mat-label>{{ 'Name' | translate }}</mat-label>
				<input
					formControlName="name"
					matInput
					type="text"
				>
				<mat-error *ngIf="this.formNameErrors as error">{{
					error.content | translate: error.args || {}
				}}</mat-error>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ 'Description' | translate }}</mat-label>
				<textarea
					formControlName="description"
					matInput
				></textarea>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions class="mat-action-filled">
	<button
		(click)="this.addEntry()"
		[disabled]="this.wsGroup.invalid"
		class="mat-action-filled"
		color="primary"
		mat-flat-button
	>
		{{ 'workspace.create' | translate }}
	</button>
</mat-dialog-actions>
